import moment from 'moment';
import queryString from 'qs';

const getScheduleHostListRequest = (data) => {
  const payload = {
    startedAt: moment(data.startedAt || data?.startDate).toISOString(),
    endedAt: moment(data.endedAt || data?.endDate).toISOString(),
    'brands.name': data.brandName,
  };

  return queryString.stringify(payload, { skipEmptyString: true });
};

export default getScheduleHostListRequest;
